import { StateType, ActionsParams, VisitedViewInfo } from './types';
import { match } from 'path-to-regexp';

const tagsViewStore: any = {
  state: {
    visitedViews: [],
    cachedViews: [],
  },
  getters: {
    visitedViews(state: StateType) {
      return state.visitedViews;
    },
    cachedViews(state: StateType) {
      return state.cachedViews;
    },
  },
  mutations: {
    COVER_VISITED_VIEW: (state: StateType, view: VisitedViewInfo[]) => {
      if (view.length) {
        state.visitedViews = view;
      }
    },
    ADD_VISITED_VIEW: (state: StateType, view: VisitedViewInfo) => {
      state.visitedViews.forEach((item, index) => {
        if (item.fullPath.split('?')[0] === view.fullPath.split('?')[0]) {
          state.visitedViews[index] = Object.assign({}, view, {
            title: view.meta.title || 'no-title',
            fullPath: view.fullPath || 'no-fullPath',
            query: view.query,
          });
        }
      });
      if (state.visitedViews.some((v) => v.fullPath.split('?')[0] === view.fullPath.split('?')[0])) {
        return;
      }
      const visitedView = Object.assign({}, view, {
        title: view.meta.title || 'no-title',
        fullPath: view.fullPath || 'no-fullPath',
        query: view.query,
      });
      if (view.affix) {
        state.visitedViews.unshift(visitedView);
      } else {
        state.visitedViews.push(visitedView);
      }
    },
    ADD_CACHED_VIEW: (state: StateType, view: VisitedViewInfo) => {
      view.matched.forEach((i: any) => {
        if (state.cachedViews.includes(i.name)) {
          return;
        }
        if (!i.meta.noCache && i.path) {
          state.cachedViews.push(i.name);
        }
      });
    },

    UPDATE_VISITED_TITLE: (state: any) => {
      for (const view of state.visitedViews) {
        Object.keys(state.microRoutes).forEach((key) => {
          const routes = state.microRoutes[key];
          const lang = state.microLang[key];
          routes.forEach((router: any) => {
            if (view.name && view.path && router.path && router.path.indexOf('*') < 0) {
              const matchFunction = match(`/${view.name}${router.path}`);
              const result = matchFunction(view.path);
              if (result) {
                if (lang && lang.global) {
                  view.title = lang.global.t(router.meta.title);
                } else {
                  view.title = router.meta.title;
                }
              }
            }
          });
        });
      }
    },

    DEL_VISITED_VIEW: (state: StateType, view: VisitedViewInfo) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1);
          break;
        }
      }
    },
    DEL_CACHED_VIEW: (state: StateType, view: VisitedViewInfo) => {
      view.matched.forEach((item: any) => {
        if (!item.path) {
          return false;
        }
        for (const i of state.cachedViews) {
          if (i === item.name) {
            const index = state.cachedViews.indexOf(i);
            state.cachedViews.splice(index, 1);
            break;
          }
        }
      });
    },

    DEL_OTHERS_VISITED_VIEWS: (state: StateType, view: VisitedViewInfo) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1);
          break;
        }
      }
    },
    DEL_OTHERS_CACHED_VIEWS: (state: StateType, view: VisitedViewInfo) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i);
          state.cachedViews = state.cachedViews.slice(index, index + 1);
          break;
        }
      }
    },

    DEL_ALL_VISITED_VIEWS: (state: StateType) => {
      state.visitedViews = [];
    },
    DEL_ALL_CACHED_VIEWS: (state: StateType) => {
      state.cachedViews = [];
    },

    UPDATE_VISITED_VIEW: (state: StateType, view: VisitedViewInfo) => {
      for (const v of state.visitedViews) {
        if (v.path === view.path) {
          Object.assign(v, view);
          break;
        }
      }
    },
  },
  actions: {
    addView({ dispatch, commit }: ActionsParams, view: VisitedViewInfo) {
      dispatch('addVisitedView', view);
      dispatch('addCachedView', view);
      commit('UPDATE_VISITED_TITLE');
    },
    addVisitedView({ commit }: ActionsParams, view: VisitedViewInfo) {
      commit('ADD_VISITED_VIEW', view);
    },
    addCachedView({ commit }: ActionsParams, view: VisitedViewInfo) {
      commit('ADD_CACHED_VIEW', view);
    },
    delView({ dispatch, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        dispatch('delVisitedView', view);
        dispatch('delCachedView', view);
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews],
        });
      });
    },
    delVisitedView({ commit, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEW', view);
        resolve([...state.visitedViews]);
      });
    },
    delCachedView({ commit, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        commit('DEL_CACHED_VIEW', view);
        resolve([...state.cachedViews]);
      });
    },

    delOthersViews({ dispatch, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        dispatch('delOthersVisitedViews', view);
        dispatch('delOthersCachedViews', view);
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews],
        });
      });
    },
    delOthersVisitedViews({ commit, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VISITED_VIEWS', view);
        resolve([...state.visitedViews]);
      });
    },
    delOthersCachedViews({ commit, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_CACHED_VIEWS', view);
        resolve([...state.cachedViews]);
      });
    },

    delAllViews({ dispatch, state }: ActionsParams, view: VisitedViewInfo) {
      return new Promise((resolve) => {
        dispatch('delAllVisitedViews', view);
        dispatch('delAllCachedViews', view);
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews],
        });
      });
    },
    delAllVisitedViews({ commit, state }: ActionsParams) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VISITED_VIEWS');
        resolve([...state.visitedViews]);
      });
    },
    delAllCachedViews({ commit, state }: ActionsParams) {
      return new Promise((resolve) => {
        commit('DEL_ALL_CACHED_VIEWS');
        resolve([...state.cachedViews]);
      });
    },

    updateVisitedView({ commit }: ActionsParams, view: VisitedViewInfo) {
      commit('UPDATE_VISITED_VIEW', view);
    },
  },
};

export default tagsViewStore;
